import { render, staticRenderFns } from "./RemoteZoneBottom.vue?vue&type=template&id=73bf487d&scoped=true"
import script from "./RemoteZoneBottom.vue?vue&type=script&lang=js"
export * from "./RemoteZoneBottom.vue?vue&type=script&lang=js"
import style0 from "./RemoteZoneBottom.vue?vue&type=style&index=0&id=73bf487d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73bf487d",
  null
  
)

export default component.exports